import {
  GitCompare,
  MapPinHouse,
  MonitorSmartphone,
  NotebookText,
  Users,
} from 'lucide-react';
import * as React from 'react';

import { NavPages } from '@/components/NavPages';
import { NavUser } from '@/components/NavUser';
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/Sidebar';
import {
  getKeycloakName,
  getKeycloakUsername,
} from '@/features/Keycloak/keycloakService';
import { FeatureName } from '@/models/role.models';
import hasPermission from '@/utils/permission.function';
import { Link } from 'react-router';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const name = getKeycloakName();
  const userName = getKeycloakUsername();

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader className="text-center">
        {/* <TeamSwitcher teams={data.teams} /> */}
        <Link to="/devices" className="justify-starts flex items-center gap-3">
          <img src="/senhub_logo.svg" className="w-[45px]" alt="logo" />

          <div className='first:mt-0" scroll-m-20 text-xl font-semibold tracking-tight [&>span:last-child]:truncate'>
            <span>SenHUB</span>
          </div>
        </Link>
      </SidebarHeader>
      <SidebarContent>
        <NavPages
          groupLabel="Device"
          pages={[
            {
              name: 'Devices',
              url: '/devices',
              icon: MonitorSmartphone,
              feature: FeatureName.VIEW_LIST_DEVICES_PAGE,
            },
            {
              name: 'Compare Devices',
              url: '/devices/compare',
              icon: GitCompare,
              feature: FeatureName.VIEW_DEVICE_COMPARE_PAGE,
            },
          ].filter((page) => hasPermission(page.feature))}
        />
        <NavPages
          pages={[
            {
              name: 'Sites',
              url: '/sites',
              icon: MapPinHouse,
              feature: FeatureName.VIEW_LIST_SITES_PAGE,
            },
            {
              name: 'Customers',
              url: '/customers',
              icon: Users,
              feature: FeatureName.VIEW_LIST_CUSTOMERS_PAGE,
            },

            {
              name: 'Audit History',
              url: '/audits',
              icon: NotebookText,
              feature: FeatureName.VIEW_AUDIT_HISTORY,
            },
          ].filter((page) => hasPermission(page.feature))}
        />
      </SidebarContent>
      <SidebarFooter>
        <NavUser
          user={{
            name,
            userName,
          }}
        />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
